"use client";

import { usePathname } from "next/navigation";
import Header from "./Header";
import Footer from "./Footer";

export default function ConditionalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  // Check if current page should be full screen (no navbar/footer)
  const isFullScreen = pathname?.includes("/learn") || pathname?.includes("/recording/");

  // Check if current page uses its own header/footer (custom layout pages)
  const hasCustomLayout = pathname?.includes("/bpr-preview") || pathname?.includes("/bevent") || pathname?.includes("/org/");

  if (isFullScreen || hasCustomLayout) {
    return <>{children}</>;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
}
